<template>
  <div
    id="refineSearchMsg"
    class="col text-center alert alert-warning primary"
  >
    {{ message }}
    <a
      class="alert-link"
      href="#"
      @click="clicked"
    >Back to Top</a>
  </div>
</template>

<script>
export default {

    props: {
        message: {
            type: String,
            default: ""
        },
    },

    methods: {
        clicked(event) {
            event.preventDefault();
            this.$emit('clicked');
        }
    }
};
</script>
<style scoped>

</style>
